'use strict';

/**
 * VA Segment tracking front-end helper.
 */
export class VASegmentTracking {
  /**
   * Class constructor.
   *
   * @param string brandName
   * @param string source
   * @param string userId
   */
  constructor(brandName, source, userId) {
    if (!window.analytics) {
      throw new Error('Missing Segment analytics object.');
    }
    this.brandName = brandName;
    this.source = source;
    this.userId = userId;
  }

  /**
   * Init Segmentio front-end object with a key.
   *
   * @param string segmentKey
   */
  static load(segmentKey) {
    window.analytics.load(segmentKey)
  }

  /**
   * Page event helper.
   *
   * @param string name
   * @param object properties
   */
  page(name, properties) {
    window.analytics.page(name, {
      ...properties,
      company: this.brandName,
      source: this.source,
      userId: this.userId ? this.userId : null
    })
  }

  /**
   * Track event helper.
   *
   * @param string name
   * @param object properties
   */
  track(name, properties) {
    window.analytics.track(name, {
      ...properties,
      company: this.brandName,
      source: this.source
    })
  }

  /**
   * Common Identify event helper.
   */
  identify() {
    if (this.userId) {
      window.analytics.identify(this.userId)
    }
  }

  /**
   * Common reset helper.
   */
  static reset() {
    window.analytics.reset()
  }
};
